import React from 'react';
import './detallerubro.css';
import { rubros } from '../../json/rubros';
//import { rubros_externo } from '../../json/rubros_externo';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';

const DetalleRubro = () => {
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { nombre } = useParams();
  const rubro = rubros.find((rubro) => rubro.nombre === nombre);
  //const rubro_externo = rubros_externo.find((rubroex) => rubroex.nombre === nombre);

  return (
    <div className='container container_detalle_rubro'>
      <div className='row'>
        <div className='col-12'>
          <div className='rubro_titulo'>
            <h3 className='title'>{rubro.nombre}</h3>
            <hr className='hr-gob' />
          </div>
        </div>
      </div>
      
      <div className='row'>
        
        {
          rubro.formatos.map((formato, index) => {
            
            if(formato.externo == "si"){
              const urlXLSX = formato.xlsx_liga;
              const urlHTML = formato.htm_liga;
              return (
                <div key={ index } className='col-md-4 col-12'>
                  <div className='rubro_container_detalle'>
                    <div className='detalle_rubro_nombre'>
                      <h5>{ formato.nombre }</h5>
                    </div>
                    <div className='detalle_rubro_enlaces'>
                      <a href={ urlXLSX } target="_blank">XLSX</a>
                      <a href={ urlHTML } target="_blank">Ver Tabla</a>
                    </div>
                  </div>
                </div>
              );
            }else{
               const urlXLSX = "/Transparencia/xlsx/2026/a69_" + formato.xlsx + "_STPSH.xlsx";
               const urlHTML = "/Transparencia/htm/a69_" + formato.html + "_STPSH.htm";
               return (
                <div key={ index } className='col-md-4 col-12'>
                  <div className='rubro_container_detalle'>
                    <div className='detalle_rubro_nombre'>
                      <h5>{ formato.nombre }</h5>
                    </div>
                    <div className='detalle_rubro_enlaces'>
                      <a href={ urlXLSX } target="_blank">XLSX</a>
                      <a href={ urlHTML } target="_blank">Ver Tabla</a>
                    </div>
                  </div>
                </div>
              );
            }

            
           
          })
        }
      
        
      </div>

    </div>
  );
};

export default DetalleRubro;
